import { createSelector } from 'reselect';

export const selectPermissionsSlice = state => state.permissions;

export const selectPermissions = createSelector(
  selectPermissionsSlice,
  slice => slice.permissions
);
export const permissionsMeta = createSelector(
  selectPermissionsSlice,
  slice => slice.meta
);

export const getPermissionsTree = createSelector(
  selectPermissionsSlice,
  slice => {
    const { permissions } = slice;
    let permissionsTree = [];

    for (let i = 0; i < permissions.length; i++) {
      const parts = permissions[i].name.split('.');

      let lvl1 = permissionsTree.find(obj => obj.value === parts[0]);
      if (!lvl1) {
        permissionsTree.push({
          label: parts[0].charAt(0).toUpperCase() + parts[0].slice(1),
          value: parts[0],
          children: []
        });
      }

      if (parts.length === 2) {
        lvl1 = permissionsTree.find(obj => obj.value === parts[0]);

        lvl1.children.push({
          value: String(permissions[i].id),
          label: parts[1].charAt(0).toUpperCase() + parts[1].slice(1)
        });
      }

      if (parts.length === 3) {
        lvl1 = permissionsTree.find(obj => obj.value === parts[0]);
        let lvl2 = lvl1.children.find(obj => obj.value === parts[0] + '.' + parts[1]);

        if (!lvl2) {
          lvl1.children.push({
            value: parts[0] + '.' + parts[1],
            label: parts[1].charAt(0).toUpperCase() + parts[1].slice(1),
            children: []
          });
        }

        lvl2 = lvl1.children.find(
          obj => obj.value === parts[0] + '.' + parts[1]
        );

        lvl2.children.push({
          value: String(permissions[i].id),
          label: parts[2].charAt(0).toUpperCase() + parts[2].slice(1)
        });
      }
    }

    return permissionsTree;
  }
);
